import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { SlideService } from 'src/app/services/slide.service';

@Component({
  selector: 'app-open-carrusel-galleries',
  templateUrl: './open-carrusel-galleries.component.html',
  styleUrls: ['./open-carrusel-galleries.component.scss'],
})
export class OpenCarruselGalleriesComponent implements OnInit, AfterViewInit {
  @ViewChild('slideGallery', { static: true }) slideGallery: IonSlides;
  @ViewChild('previewImages', { static: true })
  previewImages: ElementRef<HTMLDivElement>;
  @Input() images: any[] = [];
  @Input() selected: any = undefined;
  @Input() typeImg: string = '';
  public media: any[] = [];
  public selectedMedia: string = '';
  public reachedEnd = false;
  public isStart = true;

  constructor(
    private modalController: ModalController,
    private slideSv: SlideService
  ) {}

  ngOnInit() {
    this.images.forEach((x) => {
      this.media.push(...x.media);
    });

    const selectedImg = this.selected.media[0].file;
    const indexImg = this.media.findIndex((x) => x.file === selectedImg);
    this.selectedMedia = selectedImg;
    this.slideGallery.slideTo(indexImg);
  }

  async goTo(next) {
    (await next)
      ? this.slideGallery.slideNext(400)
      : this.slideGallery.slidePrev(400);
  }

  ngAfterViewInit(): void {
    setTimeout(async () => {
      this.reachedEnd = await this.slideSv.isEnd(this.slideGallery);
    });
  }

  async changeSlides(ev) {
    this.reachedEnd = ev.el.dom7ElementDataStorage.swiper.isEnd;
    if (!this.reachedEnd || this.reachedEnd) {
      this.isStart = ev.el.dom7ElementDataStorage.swiper.isBeginning;
    }
    this.setImageAndScroll();
  }

  async setImageAndScroll() {
    this.selectedMedia =
      this.media[await this.slideGallery.getActiveIndex()].file;
    const containerDiv = this.previewImages.nativeElement;
    const elm: HTMLElement = document.getElementById(this.selectedMedia);
    containerDiv.scrollLeft = elm.offsetLeft - elm.offsetWidth / 2;
  }

  async setImage(file, index) {
    await this.slideGallery.slideTo(index);
    this.selectedMedia = file;
  }

  close() {
    this.modalController.dismiss();
  }
}
